import VueScrollactive from 'vue-scrollactive';
import Vue from 'vue';

Vue.use(VueScrollactive);
